"use client";

import { useEffect, useRef } from "react";
import { VTURB_ACCOUNT_ID, VTURB_PLAYER_ID } from "@/lib/config";

// Lecteur VSL (vturb / converteai smartplayer). C'est un web component
// (<vturb-smartplayer>) qui gère lui-même sa miniature, l'autoplay et le ratio
// 16:9 (padding 56.25% du placeholder). On injecte le markup + le script à la
// main (comme l'embed officiel) pour laisser le web component piloter son
// sous-arbre sans que React tente de le réconcilier.
const PLAYER_ID = `vid-${VTURB_PLAYER_ID}`;
const SCRIPT_SRC = `https://scripts.converteai.net/${VTURB_ACCOUNT_ID}/players/${VTURB_PLAYER_ID}/v4/player.js`;

export function VSL() {
  const mountRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const mount = mountRef.current;
    // Idempotent : on ne (ré)injecte pas si le player est déjà présent.
    if (!mount || mount.childElementCount > 0) return;

    mount.innerHTML =
      `<vturb-smartplayer id="${PLAYER_ID}" style="display:block;margin:0 auto;width:100%">` +
      `<div class="vturb-player-placeholder" style="position:relative;width:100%;padding:56.25% 0 0;z-index:0;background-color:black"></div>` +
      `</vturb-smartplayer>`;

    // Charge le player.js une seule fois (survit aux montages/démontages du VSL).
    if (!document.querySelector(`script[src="${SCRIPT_SRC}"]`)) {
      const s = document.createElement("script");
      s.src = SCRIPT_SRC;
      s.async = true;
      document.head.appendChild(s);
    }
  }, []);

  return (
    <div className="mx-auto w-full max-w-2xl overflow-hidden rounded-2xl border border-ink/10 bg-black shadow-2xl shadow-black/40">
      <div ref={mountRef} />
    </div>
  );
}
